import React, { useEffect, useState, FC } from "react";
import { Helmet } from "react-helmet";
import VantourHero from "./components/VantourHero";
import VantourCardgridCard from "./components/VantourCardgrid";
import { vanToursApi } from "services/apiServices";
import SectionSubHero from "components/SectionSubHero";
import LoadingSpinner from "components/LoadingSpinner";
import NoDataFound from "components/NoDataFound";

export interface PageVantoursProps {
  className?: string;
}

const PageVantours: FC<PageVantoursProps> = ({ className = "" }) => {
  const [vanTourData, setvanTourData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const response = await vanToursApi();

      if (response.data) {
        if (response.data.response === "success") {
          console.log("Van tours data", response.data);
          let tempData: any = [];
          
          response.data.vanTour.forEach((item: any, key: number) => {
            tempData[key] = {
              id: item.id,
              title: item.package_name,
              featuredImage: item.image,
            };
          });
          
          setvanTourData(tempData);
        } else {
          setError("Failed to load van tours");
        }
      }
    } catch (err) {
      console.error("Error fetching van tours:", err);
      setError("An error occurred while fetching van tours");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div
      className={`nc-PageVantours relative overflow-hidden ${className}`}
      data-nc-id="PageVantours"
    >
      <Helmet>
        <title>VAN TOURS | EUROPE TOURS & TRAVELS</title>
      </Helmet>

      <SectionSubHero
        title="Our Van Tours"
        pillTitle="Van Tours"
        bgClass="dashboard-van-bg"
        description="Experience comfortable, scenic van journeys with personalized routes and expert guides across stunning destinations."
        className="pl-6 pt-10 lg:pt-10 lg:pb-10 mb-16"
      />

      <div className="container relative mt-4 md:mt-0 lg:mt-0 xl:mt-0">
      
        {isLoading && (
          <LoadingSpinner text="Loading Van Tours..." />
        )}

        {!isLoading && vanTourData.length === 0 && !error && (
          <NoDataFound
            title="No Van Tours Available"
            description="We couldn't find any van tours at the moment. Please check back later."
          />
        )}

        {!isLoading && error && (
          <NoDataFound
            title="Unable to Load Van Tours"
            description={error}
          />
        )}

        {!isLoading && vanTourData.length > 0 && (
          <VantourCardgridCard
            data={vanTourData}
            className="pb-24 lg:pt-32 lg:pb-16"
          />
        )}
      </div>
    </div>
  );
};

export default PageVantours;
